import React from "react";

import './style.css'
import ImgCartierLogo from '../../../images/ministry-of-education.jpg'
import ImgPhilippeLogo from '../../../images/patek-philippe-logo.jpg'
import ImgAwsLogo from '../../../images/aws-logo.jpg'
import ImgMonetarySingaporeLogo from '../../../images/monetary-authority-singapore-logo.jpg'
import ImgAsiaPlatformLogo from '../../../images/asian-art-platform-logo.jpg'

/* eslint import/no-webpack-loader-syntax: off */
import SvgFrameBold from "-!svg-react-loader!../../../icons/frame-bold.svg";
export default function PreviousJobs({ container = '' }) {
    return (
        <section className={`section previous ${container}`}>
            <div className="main-container">
                <div className="previous__title__box">
                    <h3 className="previous__title">Some of our previous projects include</h3>
                    <SvgFrameBold className="previous__title__icon"/>
                </div>
                <div className="previous__clients">
                    <div className="previous__client">
                        <img src={ImgCartierLogo} alt="brend label"/>
                    </div>
                    <div className="previous__client">
                        <img src={ImgPhilippeLogo} alt="brend label"/>
                    </div>
                    <div className="previous__client">
                        <img src={ImgAwsLogo} alt="brend label"/>
                    </div>
                    <div className="previous__client">
                        <img src={ImgMonetarySingaporeLogo} alt="brend label"/>
                    </div>
                    <div className="previous__client">
                        <img src={ImgAsiaPlatformLogo} alt="brend label"/>
                    </div>
                </div>
            </div>
        </section>
    )
}


// WEBPACK FOOTER //
// ./src/new-components/templates/previous-jobs/index.js